/**
 * 默认矩形编辑配置
 */
export default {
    strokeStyle: '#ee5026',
    lineWidth: 5
};